
    var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',_vm._g({attrs:{"xmlns":"http://www.w3.org/2000/svg","xmlns:xlink":"http://www.w3.org/1999/xlink","width":"16","height":"16","viewBox":"0 0 16 16"}},_vm.$listeners),[_c('path',{attrs:{"d":"M0 10h2a8 8 0 0 1 8-8V0A10 10 0 0 0 0 10"}}),_vm._v(" "),_c('path',{attrs:{"d":"M4 10h2a4 4 0 0 1 4-4V4a5.994 5.994 0 0 0-6 6"}}),_vm._v(" "),_c('path',{attrs:{"d":"M14 16h-4a2 2 0 0 1-2-2v-4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2"}})])}
var staticRenderFns = []

    export default {
      render: render,
    }
  